export default "__VITE_ASSET__rbdPSeim__"